export interface NotificationsPreferencesType {
  showNotificationStatus: Array<NotificationsStatus>;
  notificationLocation: NotificationsLocation;
  notificationFadeOutTime: number;
}

export enum NotificationsLocation {
  RIGHT = 'RIGHT',
  LEFT = 'LEFT',
  CENTER = 'CENTER'
}

export enum NotificationsStatus {
  FILLED = 'FILLED',
  PARTIALLY_FILLED = 'PARTIALLY_FILLED',
  REJECTED = 'REJECTED'
}
